﻿<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const {t} = useI18n();

</script>

<template>
  <div class="made-by-ai-badge">
    <img src="img/AI-Sparkles.svg" alt="Made by AI" width="16px" height="16px"/>
    <span>{{ t('message_made_by_AI') }}</span>
  </div>

</template>

<style scoped lang="scss">
.made-by-ai-badge {
  display: inline-flex;
  height: 30px;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(35, 147, 208, 0.11) 0%, rgba(154, 86, 184, 0.11) 100%);

  img {
    width: 16px;
    height: 16px;
  }

  span {
    margin-inline-start: 8px;
    color: #030303
  }
}

</style>
